import Vue from 'vue'
import VuePapaParse from 'vue-papa-parse'

Vue.use(VuePapaParse)
